export const mapNewsStatus = (status: 'CREATED' | 'PUBLISHED' | 'EXPIRED') => {
  const statuses = {
    CREATED: 'Создана',
    PUBLISHED: 'Опубликована',
    EXPIRED: 'Срок истек/убрана из публикации',
  };

  return statuses[status];
};
